// src/pages/OrderManage.js
import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { useListPageFilter, comma, dateFormatToISOString, ReservationStatusType, calculateAge, dateFormatDateTime } from "@/utils";
import { Confirm, PageTabs, Pagination, Toast } from "@/components";
import { useGetCarLocationListQuery } from "@/redux/carLocationApi";
import { useGetParkingLotListQuery } from "@/redux/parkingLotApi";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import { useGetOrderLiveListMutation, usePutConfirmOrderMutation } from "@/redux/orderApi";
import { chargeMethodOptions, orderSubStatusOption, orderTypeOptions, displacementOptions } from "@/constants/selectOptions";
import { useGetMyRentCorpQuery, useGetSearchRentCorpMutation } from "@/redux/rentCorpApi";

// 페이지 기본 필터
const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        status: "",
        started_at: "",
        ended_at: "",
    },
};

export const OrderManage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    // 탭(토글) 상태: "order" / "allocation"
    const [currentTab, setCurrentTab] = useState("order");

    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        orderDetailPopupStatus: false,
        partnersPopupStatus: false,
        selectedOrder: {},

        // put Confirm api
        rentCorpId: "",
        orderId: "",
        triggerSearch: false,
    });

    const { confirmStatus, orderDetailPopupStatus, partnersPopupStatus, rentCorpId, orderId, triggerSearch } = formData;

    // 탭 추가 로직
    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "실시간 오더" },
                });
            }
        };
        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const [getOrderLiveList, { data: listData, error: listError }] = useGetOrderLiveListMutation();
    const [putConfirmOrder, { data: confirmData, error: confirmError }] = usePutConfirmOrderMutation();

    useEffect(() => {
        if (triggerSearch) {
            getOrderLiveList({ params: parameters });
        }
    }, [triggerSearch]);

    useEffect(() => {
        console.log(listData);
    }, [listData]);

    // currentTab 값에 따라 API 호출
    // const {
    //     data: carLocationData,
    //     isLoading: isLoadingCarLocation,
    //     error: errorCarLocation,
    // } = useGetCarLocationListQuery(parameters, {
    //     skip: currentTab !== "order", // currentTab이 "order"가 아니면 스킵
    // });

    // const {
    //     data: parkingLotData,
    //     isLoading: isLoadingParkingLot,
    //     error: errorParkingLot,
    // } = useGetParkingLotListQuery(parameters, {
    //     skip: currentTab !== "allocation", // currentTab이 "allocation"이 아니면 스킵
    // });

    // // 아래처럼 필요한 데이터를 선택해서 사용
    // const data = currentTab === "garage" ? carLocationData : parkingLotData;
    // const isLoading = currentTab === "garage" ? isLoadingCarLocation : isLoadingParkingLot;
    // const error = currentTab === "garage" ? errorCarLocation : errorParkingLot;

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);

    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    const showConfirm = (title, description, buttons) => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: title,
                confirmDescription: description,
                confirmButtons: buttons,
            },
        }));
    };

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, [name]: value },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (date, name) => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, [name]: date ? dateFormatToISOString(date) : "" },
            triggerSearch: false,
        }));
    };

    const setDateRange = (startDate, endDate) => {
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                started_at: startDate ? dateFormatToISOString(startDate) : "",
                ended_at: endDate ? dateFormatToISOString(endDate) : "",
            },
            triggerSearch: false,
        }));
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}
            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">실시간 오더</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>보험영업</li>
                                <li>실시간 오더</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                {/*<div className="toggle-list">*/}
                                {/*    <button*/}
                                {/*        type="button"*/}
                                {/*        className={`btn-toggle ${currentTab === "order" ? "active" : ""}`}*/}
                                {/*        onClick={() => setCurrentTab("order")}*/}
                                {/*    >*/}
                                {/*        전체 오더 현황*/}
                                {/*    </button>*/}
                                {/*    <button*/}
                                {/*        type="button"*/}
                                {/*        className={`btn-toggle ${currentTab === "allocation" ? "active" : ""}`}*/}
                                {/*        onClick={() => setCurrentTab("allocation")}*/}
                                {/*    >*/}
                                {/*        배정 현황*/}
                                {/*    </button>*/}
                                {/*</div>*/}
                                <span className="data-count">
                                    전체 {listData?.pagination?.totalElements ?? 0} 건
                                    {/* 전체 <b>{data?.pagination?.totalElements}</b>건 */}
                                </span>
                            </div>
                            <div className="table-buttons">
                                <button
                                    type="button"
                                    className="btn-table_option btn-complete"
                                    onClick={(e) => {
                                        navigate(`/order/register`);
                                    }}
                                >
                                    오더 생성
                                </button>
                            </div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                {/* currentTab === 'order' */}
                                {currentTab === "order" && (
                                    <table>
                                        <colgroup>
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="24%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">구분</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">요청일자</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">지역</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차량정보</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">배기량</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">고객연령</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">보험사</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">청구율</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">공업사</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상태</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">관리</span>
                                                </div>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {listData?.data && listData?.data?.length === 0 ? (
                                            <tr>
                                            <td colSpan="10" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                listData?.data?.map((item, index) => (
                                                    <tr key={`liveItem${index}`}>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-tag tag-box tag-green">
                                                                    {orderTypeOptions.find((e) => e.value === item.orderType)?.label}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span
                                                                    className="cell-desc">{dateFormatDateTime(item.createdAt)}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {item?.orderCustomer?.location2AddressCode?.address1 ?? ""}{" "}
                                                                    {item?.orderCustomer?.location2AddressCode?.address2 ?? ""}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="left">
                                                                <span
                                                                    className="cell-desc">{`(${item.carNumber ?? ""}) ${
                                                                    item.modelName ?? ""
                                                                } ${item.modelDetailName ?? ""} ${item.trimName ?? ""} ${
                                                                    item.className ?? ""
                                                                }`}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                {(() => {
                                                                    const status = displacementOptions.find(
                                                                        (e) => e.value === item?.displacement
                                                                    );
                                                                    return <span
                                                                        className={`cell-desc`}>{status?.label}</span>;
                                                                })()}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {calculateAge(new Date(item?.orderCustomer?.birthDate) ?? new Date())}세
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span
                                                                    className="cell-desc">{item?.orderInsurance?.insuranceCorpName}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span
                                                                    className="cell-desc">
                                                                    {
                                                                        item?.orderInsurance?.chargeRate ?
                                                                        (item?.orderInsurance?.chargeRate || "0") + '%' : '-'
                                                                }
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span
                                                                    className="cell-desc">{item?.orderMechanic?.mechanicCorpName}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                {(() => {
                                                                    const status = orderSubStatusOption.find(
                                                                        (e) => e.value === item?.orderSubStatus
                                                                    );
                                                                    return (
                                                                        <span
                                                                            className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label}
                                                                        </span>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span
                                                                    className="btn-cell btn-outline"
                                                                    onClick={() => {
                                                                        setFormData((prevState) => ({
                                                                            ...prevState,
                                                                            orderDetailPopupStatus: true,
                                                                            selectedOrder: item,
                                                                        }));
                                                                    }}
                                                                >
                                                                    상세보기
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                        )}
                                        </tbody>
                                    </table>
                                )}

                                {/* currentTab === 'allocation' */}
                                {currentTab === "allocation" && (
                                    <table>
                                        <colgroup>
                                            <col width="8%" />
                                            <col width="10%" />
                                            <col width="10%" />
                                            <col width="30%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                            <col width="8%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">구분</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">요청일자</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">지역</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">차량정보</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">고객연령</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">보험사</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">공업사</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">상태</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">관리</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-tag tag-box tag-green">보험대차</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">2025.01.25(토) 10:10</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">경기 하남시</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="left">
                                                        <span className="cell-desc">(국산)K8 GL3 하이브리드 노블레스 (1,598cc)</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">만 26세 이상</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">삼성</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">블루핸즈</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-tag text-error">요청중</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span
                                                            className="btn-cell btn-outline"
                                                            onClick={() => {
                                                                setFormData((prevState) => ({
                                                                    ...prevState,
                                                                    orderDetailPopupStatus: true,
                                                                }));
                                                            }}
                                                        >
                                                            상세보기
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {/* {data?.data?.length ? <Pagination pagination={data?.pagination} setFormData={setFormData} /> : null} */}
                    </div>
                </div>
            </div>

            {orderDetailPopupStatus && (
                <OrderDetailPopup
                    popupStatus={orderDetailPopupStatus}
                    layer={false}
                    onClose={() => setFormData((prev) => ({ ...prev, orderDetailPopupStatus: false }))}
                    viewData={formData.selectedOrder}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    showConfirm={showConfirm}
                />
            )}

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {partnersPopupStatus && (
                <PartnersPopup
                    layer={true}
                    onClose={async (value) => {
                        setFormData((prev) => ({
                            ...prev,
                            partnersPopupStatus: false,
                        }));
                        // return;

                        value.id &&
                            showConfirm(`배정받기`, "해당 렌트카업체로 배정을 받습니다.", [
                                {
                                    label: "예",
                                    className: "btn-primary",
                                    onClick: async () => {
                                        const body = {
                                            orderId: orderId,
                                            rentCorpId: value.id,
                                        };

                                        const res = await putConfirmOrder(body);

                                        if (res.error) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                toastMsg: res.error.message,
                                                partnersPopupStatus: false,
                                            }));
                                        }

                                        if (res.data) {
                                            res.data &&
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    toastMsg: "배정되었습니다.",
                                                    partnersPopupStatus: false,
                                                }));
                                            res.data &&
                                                setTimeout(() => {
                                                    navigate(`/order/detail/${orderId}`);
                                                }, 200);
                                        }
                                    },
                                },
                                {
                                    label: "아니오",
                                    className: "btn-cancel",
                                    onClick: () =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            confirmStatus: { confirmPopupStatus: false },
                                        })),
                                },
                            ]);

                        // value.id || setFormData((prev) => ({
                        //     ...prev, partnersPopupStatus: false
                        // }))
                        // value.id && setFormData((prev) => ({
                        //     ...prev,
                        //     partnersPopupStatus: false,
                        //     rentCorpId: value.id,
                        //     selectedPartnerName: value.corpName
                        // }))
                    }}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, [name]: value },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (date, name) => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, [name]: date ? dateFormatToISOString(date) : "" },
            triggerSearch: false,
        }));
    };

    const setDateRange = (startDate, endDate) => {
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                started_at: startDate ? dateFormatToISOString(startDate) : "",
                ended_at: endDate ? dateFormatToISOString(endDate) : "",
            },
            triggerSearch: false,
        }));
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ...pageFilter,
                                    }));
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 오더 상세 팝업
const OrderDetailPopup = ({ popupStatus, layer = true, onClose, viewData, setFormData, showConfirm }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    const [putConfirmOrder, { data: confirmData, isLoading: confirmIsLoading, error: confirmError }] = usePutConfirmOrderMutation();
    // const { formData, handleChange, setFormData } = useFormInput({
    //     toastMsg: ""
    // });

    const [item, setItem] = useState({
        id: "",
        serialNumber: "",
        orderType: "",
        orderStatus: "",
        orderSubStatus: "",
        createdAt: "",
        age: "",
        location1: "",
        location2: "",
        carInfo: "",
        customerPhone: "",
        insuranceCorpName: "",
        insReceiptNumber: "",
        expectFault: "",
        chargeMethod: "",
        chargeRate: "",
        chargeMemo: "",
    });

    useEffect(() => {
        viewData &&
            setItem({
                id: viewData.id,
                serialNumber: viewData.serialNumber,
                orderType: orderTypeOptions.find((e) => e.value === viewData.orderType)?.label,
                orderStatus: viewData.orderStatus,
                orderSubStatus: viewData.orderSubStatus,
                createdAt: dateFormatDateTime(viewData?.createdAt),
                age: calculateAge(new Date(viewData?.orderCustomer?.birthDate) ?? new Date()),
                location1: viewData.orderCustomer?.location2AddressCode?.address1 ?? "",
                location2: viewData.orderCustomer?.location2AddressCode?.address2 ?? "",
                carInfo: `${viewData.modelName ?? ""} ${viewData.modelDetailName ?? ""} ${viewData.trimName ?? ""} ${
                    viewData.className ?? ""
                }`,
                customerPhone: viewData.orderCustomer?.phone,
                insuranceCorpName: viewData.orderInsurance?.insuranceCorpName,
                insReceiptNumber: viewData.orderInsurance?.receiptNumber,
                expectFault: viewData.orderInsurance?.expectFault,
                chargeMethod: chargeMethodOptions.find((e) => e.value === viewData.orderInsurance?.chargeMethod)?.label,
                chargeRate: viewData.orderInsurance?.chargeRate,
                chargeMemo: viewData.orderInsurance?.memo,
            });
    }, [viewData]);

    useEffect(() => {
        if (popupStatus) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [popupStatus]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 200);
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleConfirm = async () => {
        showConfirm(`배정받기`, "배정을 받습니다.", [
            {
                label: "예",
                className: "btn-primary",
                onClick: async () => {
                    const body = {
                        orderId: item.id,
                        // rentCorpId: value.id,
                    };

                    const res = await putConfirmOrder(body);

                    if (res.error) {
                        setFormData((prev) => ({
                            ...prev,
                            toastMsg: res.error.message,
                            partnersPopupStatus: false,
                        }));
                    }

                    if (res.data) {
                        res.data &&
                            setFormData((prev) => ({
                                ...prev,
                                toastMsg: "배정되었습니다.",
                                partnersPopupStatus: false,
                            }));
                        res.data &&
                            setTimeout(() => {
                                navigate(`/order/detail/${item.id}`);
                            }, 200);
                    }
                },
            },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
        // setFormData((prev) => ({
        //     ...prev,
        //     partnersPopupStatus: true,
        //     orderId: item.id,
        // }));
        // return;

        // const res = await putConfirmOrder(item.id)
        //
        // if(res.error) {
        //     setFormData((prev) => ({
        //         ...prev,
        //         toastMsg: res.error.message
        //     }))
        //     handleClose()
        // }
        //
        // if(res.data) {
        //     res.data && setFormData((prev) => ({
        //         ...prev,
        //         toastMsg: '배정되었습니다.'
        //     }))
        //     res.data && setTimeout(() => {
        //         navigate(`/order/detail/${item.id}`);
        //     }, 200);
        // }
        // navigate(`/vehicle/manage/register/excel`);
    };

    const maskValue = (value, prefixLength) => {
        if (!value) return "";
        if (value.length <= prefixLength) return value;
        return value.substring(0, prefixLength) + "*".repeat(value.length - prefixLength);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={handleClose}></div>

            <div className={`popup popup-side order-detail-popup ${isVisible ? "active" : ""}`}>
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">실시간 오더 상세</span>
                    </div>
                    <div className="btn-close" onClick={handleClose}></div>
                </div>
                <div className="popup-content">
                    <div className="order-detail-info">
                        <div className="info-content">
                            <div className="detail-summary">
                                <div className="summary-info">
                                    <span className="insurance-type">{item.orderType}</span>
                                    <span className="insurance-num">{item.serialNumber}</span>
                                </div>
                                <div className="order-status">
                                    {orderSubStatusOption.find((e) => e.value === item?.orderSubStatus)?.label}
                                </div>
                            </div>
                            <div className="detail-info">
                                <div className="info-item">
                                    <div className="item-desc">
                                        {`${item.location1} ${item.location2}`} / {item.age}{" "}
                                    </div>
                                    <div className="item-date">{item.createdAt}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="side_item-container">
                        <div className="side_item-wrapper">
                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">오더 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">요청구분</span>
                                        <span className="item-desc">{item.orderType}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">차량정보</span>
                                        <span className="item-desc">{item.carInfo}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">이용지역</span>
                                        <span className="item-desc">
                                            {item.location1} {item.location2}
                                        </span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">연락처(고객)</span>
                                        <span className="item-desc">{maskValue(item.customerPhone, 3)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">보험 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">보험사</span>
                                        <span className="item-desc">{item.insuranceCorpName}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">접수번호</span>
                                        <span className="item-desc">{maskValue(item.insReceiptNumber, 4)}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">예상과실</span>
                                        <span className="item-desc">{item.expectFault}%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">청구 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">청구방식</span>
                                        <span className="item-desc">{item.chargeMethod}</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">청구율</span>
                                        <span className="item-desc">{item.chargeRate}%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">요청사항</span>
                                        <span className="item-desc">{item.chargeMemo}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel" onClick={handleClose}>
                        닫기
                    </button>
                    <button className="btn btn-primary btn-close" onClick={handleConfirm}>
                        배정 받기
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};

// 사업자 선택
const PartnersPopup = ({ layer = true, onClose, formData, setFormData }) => {
    const [query, setQuery] = useState("");
    const { data: searchData, isLoading: isLoadingSearchRentCorp, refetch } = useGetMyRentCorpQuery();

    useEffect(() => {
        refetch();
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    useEffect(() => {
        console.log(searchData);
    }, [searchData]);

    const handleRegister = () => {
        onClose();
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup service-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">사업자 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="입력하세요."
                                                name="query"
                                                onChange={(e) => setQuery(e.target.value)}
                                            />
                                        </div>
                                        {/*<div className="item-buttons">*/}
                                        {/*    <button type="button" className="btn-search" onClick={(e) => getSearchRentCorp({query: query})}>*/}
                                        {/*        검색*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"32%"} />
                                            <col width={"17%"} />
                                            <col width={"17%"} />
                                            <col width={"22%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">사업자명</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">대표자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">지역</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/*{searchData || (*/}
                                        {/*    <tbody>*/}
                                        {/*        <tr>*/}
                                        {/*            <td colSpan="12" className="data-empty">*/}
                                        {/*                <div className="cell" data-align="center">*/}
                                        {/*                    <span className="cell-desc">검색어를 입력해주세요.</span>*/}
                                        {/*                </div>*/}
                                        {/*            </td>*/}
                                        {/*        </tr>*/}
                                        {/*    </tbody>*/}
                                        {/*)}*/}
                                        {searchData && searchData?.data?.length === 0 ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="12" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            searchData?.data?.map((item, index) => (
                                                <tbody>
                                                    <tr
                                                        key={`searchResult${index}`}
                                                        onClick={(e) => {
                                                            onClose(item);
                                                        }}
                                                    >
                                                        <td>
                                                            <div className="cell">
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox">
                                                                        <input
                                                                            type="checkbox"
                                                                            id="checkAll"
                                                                            name="checkAll"
                                                                            // onChange={(e) => handleChange(e)}
                                                                            // checked={filter.checkAll}
                                                                        />
                                                                        <label htmlFor=""></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.corpName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.repName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.address}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.corpNumber}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ))
                                        )}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel">취소</button>
                    <button className="btn btn-primary btn-confirm">완료</button>
                </div>
            </div>
        </>,
        document.body
    );
};
